import "slick-carousel/slick/slick";
import blazy from '../js/blazy';
(function() {
    'use strict';

    const carousel = {
        dots: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        variableWidth: true,
        centerMode: true,
        centerPadding: '60px',
        rows: 0,
        prevArrow: '<button class="slick-arrow-prev btn-link"><i class="far fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button class="slick-arrow-next btn-link"><i class="far fa-angle-right" aria-hidden="true"></i></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const $carousel = $('[data-slick="carousel"]');
    if ($carousel.length > 0) {
        $carousel.slick(carousel);
    }

    const slider = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 6000,
        rows: 0,
        prevArrow: '<button class="slick-arrow-prev"><i class="far fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button class="slick-arrow-next"><i class="far fa-angle-right" aria-hidden="true"></i></button>',
    }
    
    const $slider = $('[data-slick="slider"]');
    
    if ($slider.length > 0) {
        $slider.slick(slider);
    }
    
    const gallery = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        rows: 0,
        prevArrow: '<button class="slick-arrow-prev position-absolute top-50 left-0 translate-middle zindex-1"><i class="far fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button class="slick-arrow-next position-absolute top-50 left-100 translate-middle"><i class="far fa-angle-right" aria-hidden="true"></i></button>',
    }
    const $gallery = $('[data-slick="gallery"]');

    if ($gallery.length > 0) {
        $gallery.slick(gallery);
    }
    
    const entries = {
        "slidesToShow":3,
        "slidesToScroll":3,
        "dots":false,
        "fade":false,
        "infinite":false,
        "rows":0,
        "prevArrow":"#news-prev",
        "nextArrow":"#news-next",
        "responsive":[
            {"breakpoint":992,
            "settings":{"slidesToShow":3,
            "slidesToScroll":3}},{"breakpoint":768,
            "settings":{"slidesToShow":2,
            "slidesToScroll":2}},{"breakpoint":576,
            "settings":{"slidesToShow":1,
            "slidesToScroll":1}}
        ]
    };

    const $entries = $('[data-slick="entries"]');
    if ($entries.length > 0) {

        $entries.each((i, el) => {
            $(el).slick($.extend(entries, JSON.parse(el.dataset.slickOveride)));
        });

    }
    $('[data-slick]').on('beforeChange', function(){
        blazy.revalidate()
    })
})();
